import { getAuthToken } from '@feat-auth/auth.config';
import axios, { AxiosInstance } from 'axios';
import { useEffect } from 'react';

const setupAxios = (axios: AxiosInstance) => {
  axios.defaults.headers.Accept = 'application/json';
  axios.defaults.headers['Content-Type'] = 'application/json';

  axios.interceptors.request.use(
    (config) => {
      const auth = getAuthToken();
      if (auth) {
        config.headers.Authorization = `Bearer ${auth}`;
      }
      return config;
    },
    (err) => Promise.reject(err)
  );

  axios.interceptors.response.use(
    (response) => {
      return Promise.resolve(response);
    },
    (error) => {
      // Note: 401 handling is now done by ApiInterceptorProvider to avoid conflicts
      // Legacy 401 handler removed to prevent double-handling and redirect loops
      return Promise.reject(error);
    }
  );
};

const UseAxiosInitSetup = () => {
  useEffect(() => {
    setupAxios(axios);
  }, []);

  return null;
};

export default UseAxiosInitSetup;
